export const GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF= "GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF"
export const GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS = "GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS"
export const GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_FAIL = "GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_FAIL"

export const RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_API_ERROR = "API_ERROR"